import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/stms/FrontEnd/node_modules/next/dist/client/app-dir/link.js");
